module.exports = __webpack_public_path__ + "img/Teilnehmer_innen.363b656c.jpg";